import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {SaleOrderTypeService} from 'app/blocks/service/api/sale-order-type.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ISaleOrderType} from 'app/blocks/model/sale-order-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {SaleOrderType} from 'app/blocks/model/sale-order-type.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class SaleOrderTypeResource extends AbstractEntityResource<ISaleOrderType> {
    constructor(saleOrderTypeService: SaleOrderTypeService, router: Router) {
        super(
            Resource.SALE_ORDER_TYPES,
            saleOrderTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.SALE_ORDER_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.SALE_ORDER_TYPES),
            (entity?) => new SaleOrderType(entity),
            (entity) => entity.code
        );
    }
}
